export default "__VITE_ASSET__CAiD$SfV__"